module.exports = __webpack_public_path__ + "assets/img/11_738.b99a608b.jpg";